module.exports = __webpack_public_path__ + "static/media/kc-vector-black.36eb58bc.pdf";